import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {ScannerService} from '@proleis/proleis-rest-client';

@Component({
  selector: 'ps-scanner-sheet',
  templateUrl: 'scanner.sheet.component.html'
})
export class ScannerSheetComponent implements OnInit {

  sequenceName: string;
  sequenceDescription: string;
  objectName: string;
  objectDescription: string;

  constructor(private bs: MatBottomSheetRef<ScannerSheetComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public scanEvent,
              private scannerService: ScannerService) {
  }

  ngOnInit() {
    this.scannerService.evaluateScanCode(this.scanEvent).subscribe(result => {
      this.sequenceName = result.sequenceName;
      this.sequenceDescription = result.sequenceDescription;
      this.objectName = result.scanObjects[0].name;
      this.objectDescription = result.scanObjects[0].description;
    });
  }

  confirm() {
    this.bs.dismiss(true);
  }

  dismiss() {
    this.bs.dismiss(false);
  }

}
